var _excluded = ["color"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from 'react';
import { styled, forwardRef } from '@grupoboticario/flora-react-system';
import { filterUndefined } from '@grupoboticario/flora-react-utils';
var DEFAULT_TAG = 'h1';
var setFontStyle = (fontFamily, fontSize, lineHeight, desktop) => ({
  fontFamily,
  fontSize,
  lineHeight,
  '@desktop': desktop
});
var StyledHeading = styled(DEFAULT_TAG, {
  margin: '0',
  padding: '0',
  variants: {
    level: {
      1: setFontStyle('$primary', '4rem', '72px', {
        fontSize: '6rem',
        lineHeight: '104px'
      }),
      2: setFontStyle('$primary', '3rem', '56px', {
        fontSize: '4.5rem',
        lineHeight: '80px'
      }),
      3: setFontStyle('$primary', '2.5rem', '48px', {
        fontSize: '3.5rem',
        lineHeight: '64px'
      }),
      4: setFontStyle('$primary', '2rem', '40px', {
        fontSize: '2.5rem',
        lineHeight: '48px'
      }),
      5: setFontStyle('$secondary', '1.5rem', '32px', {
        fontSize: '2rem',
        lineHeight: '40px'
      }),
      6: setFontStyle('$secondary', '1.25rem', '24px', {
        fontSize: '1.5rem',
        lineHeight: '32px'
      })
    }
  },
  defaultVariants: {
    level: '1'
  }
});

/**
 * @deprecated Esta tipagem refere-se a um componente que será descontinuado em futuras Breaking Changes do Flora.
 * @tutorial
 * {@link https://florabook.gb.tech/v2/index.html?path=/docs/core-components-heading-deprecated-guia-de-migra%C3%A7%C3%A3o--page| Acesse o guia de migração} para saber como migrar para a nova versão.
 */

/**
 * @deprecated Este componente será descontinuado em futuras Breaking Changes do Flora.
 * @tutorial
 * {@link https://florabook.gb.tech/v2/index.html?path=/docs/core-components-heading-deprecated-guia-de-migra%C3%A7%C3%A3o--page | Acesse o guia de migração} para saber como migrar para a nova versão.
 */
export var Heading = forwardRef((_ref, forwardedRef) => {
  var {
      color
    } = _ref,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  var tagName = "h" + props.level;
  if (!['h1', 'h2', 'h3', 'h4', 'h5', 'h6'].includes(tagName)) {
    tagName = DEFAULT_TAG;
  }
  var css = filterUndefined(_extends({}, props.css, {
    color
  }));
  return /*#__PURE__*/React.createElement(StyledHeading, _extends({
    ref: forwardedRef,
    "data-flora": "heading",
    as: tagName
  }, props, {
    css: css
  }));
});
//# sourceMappingURL=Heading.js.map